import React from 'react';


import { Article as ArticleOrig } from "@randajan/jet-react/dom/article";
import { Tile } from "@randajan/jet-react/dom/tile";

import "./Article.scss";
import { Diagram } from '../Diagram/Diagram';
import { Locale } from '../../assets/Locale';
import { Link } from '@randajan/jet-react/dom/link';
import { LinkBlank } from '../LinkBlank/LinkBlank';



const _particles = {
    avatar:(alt, src)=><Tile className="avatar" caption={alt} src={src} />,
    diagram:(alt, src)=><Diagram/>
}



export const Article = (props)=>{
    const { linkBlank } = props;

    const say = Locale.use();

    const src = props.storeId ? `/store/article/${say.locale}/${props.storeId}.md` : props.src;

    const fetchSrc = props.fetch || (src=>fetch(src).then(a=>a.text()));

    const pass = Object.jet.exclude(props, ["storeId", "linkBlank"]);

    return <ArticleOrig {...pass} src={src} fetch={fetchSrc} particles={_particles} overrides={{
        a:linkBlank ? LinkBlank : Link
    }}/>
}